import apiAxios from "../api/axios";


export const exportTables = (params: any ) => {
    return apiAxios.get('export/table', {responseType: 'blob', params})
}